import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import i18n from './i18n'

import Smooch from 'smooch'

// Page
import Home from '@/views/Home'
import Login from '@/views/Login'
import User from '@/views/User'
import Location from '@/views/Location'
import Machine from '@/views/Machine'
import Manage from '@/views/Manage'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Gritus Franchisee Dashboard'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'title.login',
        i18n: true,
        ignoreAuth: true
      }
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        title: 'title.user',
        i18n: true
      }
    },
    {
      path: '/location/:name',
      name: 'Location',
      component: Location,
      meta: {
        title: 'title.report',
        i18n: true
      }
    },
    {
      path: '/machine/:name',
      name: 'Machine',
      component: Machine,
      meta: {
        title: 'title.report',
        i18n: true
      }
    },
    {
      path: '/manage',
      name: 'Manage',
      component: Manage,
      meta: {
        title: 'title.manage',
        i18n: true
      }
    }
  ]
})

// Update route title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    let title = to.meta.i18n ? i18n.t(to.meta.title) : to.meta.title
    store.commit('SET_TITLE', title)
  }

  // If login but not setup smooch
  if (store.getters.hasLoggedIn && !store.state.setupSmooch) {
    Smooch.init({
      appId: process.env.VUE_APP_SMOOCH_APP_ID,
      userId: store.state.userData.id,
      jwt: store.state.smoochToken
    }).then(() => {
      store.commit('SETUP_SMOOCH')

      return Smooch.updateUser({
        surname: store.state.userData.code,
        properties: {
          name: store.state.userData.display_name,
          email: store.state.userData.email
        }
      })
    })
  }

  // If logout but already setup smooch, try destroy smooch
  if (!store.getters.hasLoggedIn && store.state.setupSmooch) {
    store.commit('DESTROY_SMOOCH')
    try {
      Smooch.destroy()
    } catch (error) {}
  }

  if (!store.getters.hasLoggedIn && !to.matched.some(record => record.meta.ignoreAuth)) {
    next({
      name: 'Login'
    })
  } else {
    next()
  }
})

export default router
